import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/p88fQAF9hGD5RsdurKWnh2/Mockup_(1x1)_-_OFN1_(A.S).webp';
export function Hero() {
  // Headline and mockup render immediately (no entrance animation) so the
  // largest contentful paint is never delayed by JavaScript.
  return <section className="relative overflow-hidden bg-surface px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-70" data-mp="12860lxyjoar2">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-primary/40" data-id="element-71" data-mp="xbpc32nfnudg" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-72" data-mp="sa9q98dflju0">
        <p className="-mb-2.5 -mt-11 font-display text-lg font-bold tracking-brand text-primary-soft sm:text-2xl" data-id="element-73" data-mp="nc87kojx3mj2">
          🌿BIOMA LÍVIDO™
        </p>
        <h1 className="mx-auto mt-5 max-w-5xl font-display text-lg font-bold text-foreground sm:text-5xl lg:text-6xl" data-id="element-74" data-mp="3d33gb2q0p1mv">
          Tené tus comidas de la semana{' '}
          <span className="text-primary-soft" data-id="element-75" data-mp="3j7zhlpe3m4ju">
            planificadas, preparadas y listas para usar.
          </span>
        </h1>
        <div className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-76" data-mp="3o73na61tdk5f">
          <img src={mockupUrl} alt="Mockup del Pack Comidas Resueltas" width="1254" height="1254" fetchPriority="high" loading="eager" decoding="async" className="aspect-square w-full drop-shadow-2xl" data-id="element-77" data-mp="39b4ip5dwy251" />
        </div>
        <div className="mx-auto max-w-2xl" data-id="element-78" data-mp="30gztsricb0s5">
          <p className="-mb-2 font-display text-base font-bold tracking-label text-highlight sm:text-xl" data-id="element-79" data-mp="30g6jxho33v5s">
            PACK COMIDAS RESUELTAS™
          </p>
          <p className="-mb-2.5 mt-3 text-sm leading-relaxed text-foreground-soft sm:text-base" data-id="element-80" data-mp="2ql6a8o67e70v">
            El sistema práctico que te ayuda a planificar, preparar y congelar tus comidas para tener opciones listas durante toda la semana.
          </p>
          <div className="-mb-3 mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-foreground-muted sm:text-sm" data-id="element-81" data-mp="2lkqx9xpu31jf">
            <span className="inline-flex items-center gap-2 rounded-full border border-foreground/15 bg-canvas px-3 py-2" data-id="element-82" data-mp="s2b6puz5ad3k">
              <FileTextIcon className="h-4 w-4 text-primary-soft" data-id="element-83" data-mp="n9qid8z0cs7f" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-foreground/15 bg-canvas px-3 py-2" data-id="element-84" data-mp="ichy92uaue3j">
              <ZapIcon className="h-4 w-4 text-highlight" data-id="element-85" data-mp="dbaqh3s5pewv" />
              Acceso inmediato
            </span>
          </div>
        </div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-7 max-w-lg" data-id="element-86" data-mp="161jcx7tq6lh9">
          <ActionButton href="#pricing" showTrust data-id="element-87" data-mp="x37bearbm3a1">
            🍽️ QUIERO MIS COMIDAS RESUELTAS
          </ActionButton>
        </motion.div>
      </div>
    </section>;
}